module.exports = __webpack_public_path__ + "img/logo.f4bd7062.png";